import { DialogContent, DialogTitle, Grid, Stack } from '@mui/material';
import {
  WsButton,
  WsDialog,
  WsIconCross,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import FeeArrangementForm from '../../../../features/clientDetails/components/contractArrangementsTab/AddEditFeeArrangement';

export interface DialogProps {
  open: boolean;
  clientId: string;
  companyName: string;
  onClose(): void;
  onSave: () => void;
}
const CreateFeeArrangementDialog = ({
  open,
  clientId,
  companyName,
  onClose,
  onSave,
}: DialogProps) => (
  <WsDialog size="medium" openDialog={open}>
    <DialogTitle>
      <Grid item container justifyContent="space-between">
        <Stack direction="row" spacing={1}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
            {`Create Fee Arrangement for `}
          </WsTypography>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.PRIMARY} bold={true}>
            {companyName}
          </WsTypography>
        </Stack>
        <WsButton startIcon={<WsIconCross />} onClick={onClose} variant="text">
          Close
        </WsButton>
      </Grid>
    </DialogTitle>
    <DialogContent>
      <FeeArrangementForm
        clientId={clientId}
        clientName={companyName}
        onCancel={onClose}
        onSave={onSave}
        modalType="modal"
      />
    </DialogContent>
  </WsDialog>
);
export default CreateFeeArrangementDialog;
